import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { MatSelect } from '@angular/material/select'
import { Select } from '@ngxs/store'
import { Observable } from 'rxjs'

import { AppState } from 'src/app/app.state'
import { TemplateLibraryPieceModel } from '../template-library/models/template-library.model'

@Component({
  selector: 'app-add-inspection-type-dialog',
  templateUrl: './add-inspection-type-dialog.component.html',
  styleUrls: ['./add-inspection-type-dialog.component.scss']
})
export class AddInspectionTypeDialogComponent implements OnInit, AfterViewInit {
  @Select(AppState.getInspectionTypeLibraryPieces) inspectionTypeLibraryPieces$: Observable<TemplateLibraryPieceModel[]>
  @Select(AppState.getInspectionDetailLangKeys) inspectionDetailLangKeys$: Observable<string[]>

  @ViewChild('inspectionTypeSelect') inspectionTypeSelect: MatSelect

  selectedInspectionType: TemplateLibraryPieceModel

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.inspectionTypeSelect) {
      setTimeout(() => this.inspectionTypeSelect.focus(), 50)
    }
  }
}
